import ActionRequestList from "./list";


if (document.body.getAttribute("data-current-path") === "action_requests") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ActionRequestList();
    }
}